import { FormCheckbox } from '@myxplor/forms'
import React, { Fragment } from 'react'
import AddSupportingEvidenceForm from './add-supporting-evidence'
import StateDetails from './state-details'


const StateTerritoryForm = ({ values, onChange, required }) => (
  <Fragment>
    <AddSupportingEvidenceForm values={values} onChange={onChange} limit={1} hasType={true}/>
    <hr />
    <StateDetails
      showNumber={false}
      isDetermination={required}
      onChange={onChange}
      values={values}
    />

    <hr />

    <fieldset>
      <FormCheckbox
        required
        label='I confirm that the information provided is true and correct'
        name='is_declaration_given'
        value={values.is_declaration_given}
        onChange={onChange}
        compact
      />
    </fieldset>
  </Fragment>
)

export default StateTerritoryForm



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/state-territory.js